import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerPsicoTcc'; 
import AboutPsicoTcc from './AboutPsicoTcc';
import Psicopedagogia from './CorpoClinicoPsicoSistemica';

const PsicoTcc = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutPsicoTcc />
        <Psicopedagogia />
      </div>
    );
  };
  
  export default PsicoTcc;
  